
import React, { Dispatch } from 'react';

import { ArrowDb } from '../redux/arrowDbSlice';
import { CardKinds } from '../redux/cardTemplateDbSlice';
import { CardTemplateAttributeDb } from '../redux/cardTemplateAttributeDbSlice';
import { StoryCard, CardDb, CommonCardAddPayload, MemoCardAddPayload, UiCardAddPayload, DrawCardAddPayload, addCard } from '../redux/cardDbSlice';
import { CardAttributeDb, CardAttributeAddPayload, addCardAttribute } from '../redux/cardAttributeDbSlice';
import { CardShapeAddPayload, addCardShape } from '../redux/cardShapeDbSlice';
import { MemoCardContentAddPayload, addMemoCardContent } from '../redux/memoCardContentDbSlice';
import { DrawCardContentAddPayload, addDrawCardContent } from '../redux/drawCardContentDbSlice';
import { FontType } from '../redux/cardAttributeModelIndex';
import CommonCard from '../card_components/CommonCard';
import UiSketchCard from '../card_components/UiSketchCard';
import MemoCard from '../card_components/MemoCard';
import DrawCard from '../card_components/DrawCard';
import EditCommonCard from './EditCommonCard';
import EditUiCard from './EditUiCard';
import EditMemoCard from './EditMemoCard';
import EditDrawCard from './EditDrawCard';
import { DrawSettingType } from '../components/DrawToolContent';

export const DefaultImageId = 'i:wRe9IQSOSd2ejbmAQC8zC';
export const UICardImageId = 'i:PLr9d_nwTUtZRZhbMGp1l';

type ComponentHashType = {
  [key in CardKinds]: React.FC<any>;
}
type ComponentInitialHashType = {
  [key in CardKinds]: Object;
}

type ComponentImageGetter = (obj: any) => string | undefined;
type ComponentImageHashType = {
  [key in CardKinds]: ComponentImageGetter | undefined;
}

// ---- コンポーネントを追加したら、これらHashにコンポーネントを追加すること

// コンポーネント名 → コンポーネント表示
const componentHash: ComponentHashType = {
  'common': CommonCard,
  'ui': UiSketchCard,
  'memo': MemoCard,
  'draw': DrawCard
};
// コンポーネント名 → コンポーネント編集画面
const componentEditorHash: ComponentHashType = {
  'common': EditCommonCard,
  'ui': EditUiCard,
  'memo': EditMemoCard,
  'draw': EditDrawCard
};
// コンポーネント名 → 画像参照 (未使用画像削除用)
const componentImageHash: ComponentImageHashType = {
  'common': undefined,
  'ui': undefined,// (obj: UiCardProps) => obj.imageId,
  'memo': undefined,
  'draw': undefined
};

// ---- デフォルト値

export const initial = {
  cardWidth: 200,
  cardHeight: 120,
  font: {
    name: 'MS PGothic',
    color: '#000000',
    size: 14,
    bold: false,
    italic: false,
    underline: false,
    direction: 'horizontal-tb',
    orientation: 'mixed',
    autoFit: true,
    yoko: 'left',
    tate: 'center'
  } as FontType,
  multiAttributeFont: {
    name: 'MS PGothic',
    color: '#000000',
    size: 14,
    bold: false,
    italic: false,
    underline: false,
    direction: 'horizontal-tb',
    orientation: 'mixed',
    autoFit: true,
    yoko: 'left',
    tate: 'start'
  } as FontType,
  textShapeFont: {
    name: 'MS PGothic',
    color: '#000000',
    size: 10,
    bold: false,
    italic: false,
    underline: false,
    direction: 'horizontal-tb',
    orientation: 'mixed',
    autoFit: true,
    yoko: 'left',
    tate: 'center'
  } as FontType,
  uiTextFont: {
    name: 'MS PGothic',
    color: '#000000',
    size: 24,
    bold: false,
    italic: false,
    underline: false,
    direction: 'horizontal-tb',
    orientation: 'mixed',
    autoFit: true,
    yoko: 'center',
    tate: 'center'
  } as FontType,
  drawSetting: {
    mode: 'pen',
    penWidth: 4,
    penColor: '#000000',
    eraserWidth: 24,
    backgroundColor: '#ffffff',
    frameDisplay: false,
    frameColor: '#000000'
  } as DrawSettingType,
  uiSketchWide: 1280,
  uiSketchNarrow: 768,
  arrow: {
    sheetId: '',
    fromId: '',
    toId: '',
    order: 0,
    thickness: 'medium',
    color: '#000000',
    lineStyle: 'solid',
    return: false,
    shapes: { head: { shape: 'arrow', size: 'medium' }, tail: { shape: 'flat', size: 'medium' } },
    labels: { head1: { label: '' }, head2: { label: '' }, middle1: { label: '' }, middle2: { label: '' }, tail1: { label: '' }, tail2: { label: '' } },
    imageId: '',
    notes: ''
  } as ArrowDb
}

// -----

export const getCardComponent = (kind: CardKinds, id: string, width?: number, height?: number): React.FunctionComponentElement<any> => {
  if (kind === 'ui') return React.createElement(componentHash[kind], { cardId: id });
  else return React.createElement(componentHash[kind], { cardId: id, widthValue: width, heightValue: height });
}

export const getAllComponentNames = (): CardKinds[] => {
  return Object.keys(componentHash) as CardKinds[];
}

export type EditCardProps = {
  card: CardDb;
  setCard: (card: CardDb) => void;
}

export const getCardEditorComponent =
  (id: string, card: CardDb, setCard: (card: CardDb) => void, attributes: CardAttributeDb[], setAttributes: (items: CardAttributeDb[]) => void)
  : React.FunctionComponentElement<any> => {
  if (card.kind !== 'common') return React.createElement(componentEditorHash[card.kind], {card: card, setCard: setCard});
  else {
    return React.createElement(componentEditorHash[card.kind], {cardId: id, items: attributes, setAttributes: setAttributes});
  }
}

export const getCardImage = (card: CardDb): string | undefined => {
  const getter = componentImageHash[card.kind];
  return getter && getter(card);
}

export const getCardSize = (card: CardDb): { width: number; height: number; } => {
  let width: number;
  let height: number;
  if (card.currentWidth) width = Math.max(card.defaultWidth, card.currentWidth);
  else width = card.defaultWidth;
  if (card.currentHeight) height = Math.max(card.defaultHeight, card.currentHeight);
  else height = card.defaultHeight;
  return { width, height };
}

// export const getComponentInitial = (id: string): Object => {
//   if (isComponentNames(id)) return componentInitialHash[id];
//   else return componentInitialHash['CommonCard'];
// }

export const getAttributeInitial = (cardId: string, templateAttributeId: string, templateAttribute: CardTemplateAttributeDb): CardAttributeDb => {
  const {cardTemplateId, ...props} = templateAttribute;
  if (props.cardAttributeModel === 'single') {
    return ({cardId: cardId, cardTamplateAttributeId: templateAttributeId, content: props.defaultContent, currentY: props.y, ...props});
  } else if (props.cardAttributeModel === 'multi') {
    return ({cardId: cardId, cardTamplateAttributeId: templateAttributeId, content: props.defaultContent, currentY: props.y, ...props});
  } else if (props.cardAttributeModel === 'table') {
    return ({cardId: cardId, cardTamplateAttributeId: templateAttributeId, content: {}, currentY: props.y, ...props});
  } else if (props.cardAttributeModel === 'image') {
    return ({cardId: cardId, cardTamplateAttributeId: templateAttributeId, content: props.defaultImage, currentY: props.y, ...props});
  } else {
    return ({cardId: cardId, cardTamplateAttributeId: templateAttributeId, content: props.defaultContent, ...props});
  }
}

type AddCommonCardValueProps = {
  dispatch: Dispatch<any>;
  card: CommonCardAddPayload;
  items: CardAttributeAddPayload[];
  shapes: CardShapeAddPayload[];
}
type AddMemoCardValueProps = {
  dispatch: Dispatch<any>;
  card: MemoCardAddPayload;
  memoContent: MemoCardContentAddPayload;
}
type AddUiSketchCardValueProps = {
  dispatch: Dispatch<any>;
  card: UiCardAddPayload;
}
type AddDrawCardValueProps = {
  dispatch: Dispatch<any>;
  card: DrawCardAddPayload;
  drawContent: DrawCardContentAddPayload;
}
export type AddCardValueProps = AddCommonCardValueProps | AddMemoCardValueProps | AddUiSketchCardValueProps | AddDrawCardValueProps | undefined;
const isCommon = (props: AddCardValueProps): props is AddCommonCardValueProps => {
  return props !== undefined && props.card.kind === 'common';
}
const isMemo = (props: AddCardValueProps): props is AddMemoCardValueProps => {
  return props !== undefined && props.card.kind === 'memo';
}
const isUi = (props: AddCardValueProps): props is AddUiSketchCardValueProps => {
  return props !== undefined && props.card.kind === 'ui';
}
const isDraw = (props: AddCardValueProps): props is AddDrawCardValueProps => {
  return props !== undefined && props.card.kind === 'draw';
}
export const addCardValue = (props: AddCardValueProps) => {
  if (!props) return;
  const dispatch = props.dispatch;

  if (isCommon(props)) {
    dispatch(addCard(props.card));
    props.items.forEach(item => dispatch(addCardAttribute(item)));
    props.shapes.forEach(shape => dispatch(addCardShape(shape)));
  } else if (isMemo(props)) {
    dispatch(addCard(props.card));
    dispatch(addMemoCardContent(props.memoContent));
  } else if (isUi(props)) {
    dispatch(addCard(props.card));
  } else if (isDraw(props)) {
    dispatch(addCard(props.card));
    dispatch(addDrawCardContent(props.drawContent));
  }
}

export const getStoryCardLines = (ids: string[], cards: StoryCard[]) => {
  type ChildrenHashType = { [key in string]: { ids: string[], cards: StoryCard[]} }
  const rootIds: string[] = [];
  const rootCards: StoryCard[] = [];
  const childrenHash: ChildrenHashType = {};
  ids.forEach((id, ix) => {
    const card = cards[ix];
    if (!card.parentId) {
      rootIds.push(id);
      rootCards.push(card);
    } else {
      if (!(card.parentId in childrenHash)) childrenHash[card.parentId] = { ids: [], cards: [] };
      childrenHash[card.parentId].ids.push(id);
      childrenHash[card.parentId].cards.push(card);
    }
  })
  return { rootIds, rootCards, childrenHash };
}
